// extracted by mini-css-extract-plugin
module.exports = {"apps-suggestions-title":"_3JfxL","appsSuggestionsTitle":"_3JfxL","title-text":"SyAAH","titleText":"SyAAH"};